import { render, staticRenderFns } from "./loginAnimation.vue?vue&type=template&id=8d228248&"
import script from "./loginAnimation.vue?vue&type=script&lang=ts&"
export * from "./loginAnimation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports